module.exports = __webpack_public_path__ + "static/project-12f-93b27433d1748e46a6448bfe8e933637.png";